<template>
    <!-- <v-app> -->
      <v-container class="mt-5">
            <v-row>
              <v-col cols="11">
                <Breadcrumb class="row justify-content-center mt-4"/>
              </v-col>
              <v-col cols="1" v-if="showLoader">
              <LoaderProgress></LoaderProgress>
              </v-col>
            </v-row>    
    <v-data-table
        :headers="headers"
        :items="opData"
        class="elevation-1"
        item-key="name"
        :mobile-breakpoint="0"
        :items-per-page=5
      >
      <template v-slot:item.approval_status="{ item }">
            <template v-if="new Date(item.to_date)<=new Date() && item.approval_status==`pending`">
              inactive
            </template>
            <template v-else-if="item.approval_status==`pending`">
              <v-btn color="success" 
              @click="adminAccessRequestResponse(item,true)"
              :disabled="disable">Accept</v-btn>
              <v-btn color="error" 
              @click="adminAccessRequestResponse(item,false)"
              :disabled="disable">Reject</v-btn>
            </template>
            <template v-else>
              {{ item.approval_status }}
          </template>
          </template>
          <template v-slot:item.status="{ item }">
            <template v-if="item.status==true">
              Active
            </template>
            <template v-else-if="item.approval_status==`pending`">
              Action not Taken
          </template>
          <template v-else>
              inactive
          </template>
          </template>
    </v-data-table>
    </v-container>
    </template>
    
    <script>
    import axios from "axios";
    import LoaderProgress from "../components/progressLoader";
    import Breadcrumb from "../components/breadcrumbs.vue";
    
    
    export default {
      
      data() {
        return {
          showLoader:false,
          opData:[],
          disable:false,
          headers:[{
            text:"Requestor",
            value:"user_name",
          },
          {
            text:"StartDate",
            value:"from_date"
          },
          {
            text:"EndDate",
            value:"to_date"
          },
          {
            text:"Status",
            value:"approval_status",
            align:"center",
          },
          {
            text:"Reason",
            value:"reason"
          },
          {
            text:"Access Name",
            value:"access_name"
          },
          {
            text:"Status",
            value:"status"
          }
        ],
    
        };
      },
      components: {
          LoaderProgress,
          Breadcrumb
        },
      mounted() {
        this.getAdminRequestData();
        // console.log(this.request)
        
      },
    
      methods: {
        getAdminRequestData(){
            this.showLoader = true;
            let config = {
              method: "get",
              url: `${this.$config.backend_url}/getadminaccessrequestdata`,
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            };
            this.noteLastAPICallTime();
            axios(config).then((response) => {
              try {
                this.opData = response.data.data
                this.showLoader = false;
              } catch (error) {
                this.showLoader = false;
                console.log(error)
              }
            });
          },
        adminAccessRequestResponse(item,status){
          this.disable=true
          item.status = status
          console.log(item,status)
          this.showLoader = true;
          let config = {
            method: "post",
            url: `${this.$config.backend_url}/adminaccessrequestresponse`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            data: item
          };
          this.noteLastAPICallTime();
          axios(config).then((response) => {
            try {
              if (response.data.status) {
                console.log("status true")
                this.disable=false
              } else {
                console.log("status false")
                this.disable=false
              }
              console.log("data-->>",response.data.data)
              this.getAdminRequestData()
              this.showLoader = false;
            } catch (error) {
              this.showLoader = false;
              console.log(error)
            }
    
          });
        },
        deactivateAccess(item){
          this.disable=true
          this.showLoader = true;
          let config = {
            method: "post",
            url: `${this.$config.backend_url}/removeadminaccess`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            data: item
          };
          this.noteLastAPICallTime();
          axios(config).then((response) => {
            try {
              if (response.data.status) {
                console.log("status true")
                this.disable=false
              } else {
                console.log("status false")
                this.disable=false
              }
              console.log("data-->>",response.data.data)
              this.getAdminRequestData()
              this.showLoader = false;
            } catch (error) {
              this.showLoader = false;
              console.log(error)
            }
    
          });
        }
      },
    };
    </script>
    
    <style>
    /* Add custom styles here */
    .v-container {
      margin-top: 40px;
    }
    
    .v-card {
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 8px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
    }
    
    .v-card-title {
      font-size: 20px;
      padding: 16px;
      background-color: #007bff;
      color: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    
    .v-card-text {
      padding: 16px;
    }
    
    .v-btn {
      margin: 8px;
    }
    </style>